import React, { useEffect, useState } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { secretKey } from "../.././data";
import Loading from "../helpers/loading_component.js";

const MySwal = withReactContent(Swal2);

const SendPostTask = (props) => {
  const [loading, setLoading] = useState(true);
  const [buffer, setBuffer] = useState([]);
  const [podOdb, setPodOdb] = useState(0);
  const [category, setCategory] = useState("EKONOMICZNA");
  const [name1, setName1] = useState("");
  const [name2, setName2] = useState("");
  const [street, setStreet] = useState("");
  const [num1, setNum1] = useState("");
  const [num2, setNum2] = useState("");
  const [city, setCity] = useState("");
  const [editGuid, setEditGuid] = useState("");
  const [postCode, setPostCode] = useState("");
  const [desc, setDesc] = useState(
    props.mode === "edit"
      ? props.desc
      : props.task
      ? `${
          props.task.sygn !== "brak danych" ? props.task.sygn : ""
        } ${props.task.client_name.replaceAll("  ", "")}`
      : `${
          props.client.aSygn && props.client.aSygn !== "brak danych"
            ? props.client.aSygn
            : ""
        } ${
          props.client.petitioner
            ? props.client.petitioner.replaceAll("  ", "")
            : ""
        }`
  );
  const [clientsAddress, setClientsAddress] = useState([]);
  const [courtAddress, setCourtAddress] = useState(null);
  const [bankAddress, setBankAddress] = useState(null);
  const [bank2Address, setBank2Address] = useState(null);
  const [bookMode, setBookMode] = useState("court");
  const [chooseAddress, setChooseAddres] = useState(1);
  const [closeSend, setCloseSend] = useState(false);
  const [buffers, setBuffers] = useState([]);

  const fetchCloseSend = async () => {
    setLoading(true);
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getSendClose ", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        var date =
          new Date().getFullYear() +
          "-" +
          (new Date().getMonth() + 1 < 10
            ? "0" + (new Date().getMonth() + 1)
            : new Date().getMonth() + 1) +
          "-" +
          (new Date().getDate() < 10
            ? "0" + new Date().getDate()
            : new Date().getDate());

        if (date === data.date) {
          setCloseSend(true);
        } else {
          setCloseSend(false);
        }

        fetchBufferList();
      })
      .catch((error) => {});
  };

  const fetchBufferList = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getBuforListPostBookList", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setBuffers(data.bufor);
        if (props.mode === "edit") {
          fetchBufferListNumNadania();
          fetchClientAddress();
        } else {
          fetchClientAddress();
        }
      })
      .catch((error) => {});
  };

  const fetchBufferListNumNadania = async () => {
    var body = {
      numNad: props.numNad,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getBuforListPostBookNumNad", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        var name1Q = "";
        var name2Q = "";
        if (data) {
          try {
            if (data.adres.attributes.nazwa.split(" ").length > 7) {
              data.adres.attributes.nazwa.split(" ").map((el, index) => {
                if (index <= 6) {
                  name1Q = name1Q + " " + el;
                } else {
                  name2Q = name2Q + " " + el;
                }
              });
            } else {
              name1Q = data.adres.attributes.nazwa;
            }
          } catch (err) {}

          setName1(name1Q);
          setName2(name2Q);
          setStreet(data.adres.attributes.ulica);
          setNum1(data.adres.attributes.numerDomu);
          setCity(data.adres.attributes.miejscowosc);
          setPostCode(data.adres.attributes.kodPocztowy);
          setEditGuid(data.attributes.guid);
          setCategory(data.attributes.kategoria);
          setPodOdb(data.attributes.iloscPotwierdzenOdbioru);
          fetchDesc();
        } else {
          setLoading(false);
        }
      })
      .catch((error) => {});
  };

  const fetchDesc = async () => {
    var body = {
      numNad: props.numNad,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getDescPost", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data) {
          var descR = data.filter((el) => el.guid === props.numNad)[0];
          if (descR) {
            setDesc(descR.descA);
          }
        }
        setLoading(false);
      })
      .catch((error) => {});
  };

  const handleOpenPdfInNewTab = (base64Pdf) => {
    try {
      var pdfData = `data:application/pdf;base64,${base64Pdf}`;

      var w = window.open("");

      if (w) {
        w.document.write(
          `<embed width="100%" height="100%" src="${pdfData}" type="application/pdf" />`
        );
      } else {
        throw new Error("Failed to open a new tab.");
      }
    } catch (error) {
      console.error("Error opening PDF in new tab:", error);
      // } finally {
      //   if (w) w.document.close();
      // }
    }
  };

  const fetchAdd = async () => {
    setLoading(true);
    var date = "";

    if (closeSend) {
      date =
        new Date().getFullYear() +
        "-" +
        (new Date().getMonth() + 1 < 10
          ? "0" + (new Date().getMonth() + 1)
          : new Date().getMonth() + 1) +
        "-" +
        (new Date().getDate() + 1 < 10
          ? "0" + (new Date().getDate() + 1)
          : new Date().getDate() + 1);
    } else {
      date =
        new Date().getFullYear() +
        "-" +
        (new Date().getMonth() + 1 < 10
          ? "0" + (new Date().getMonth() + 1)
          : new Date().getMonth() + 1) +
        "-" +
        (new Date().getDate() < 10
          ? "0" + new Date().getDate()
          : new Date().getDate());
    }

    var body = {
      podOdb: podOdb,
      category: category,
      name1: name1,
      name2: name2,
      street: street,
      num1: num1,
      num2: num2,
      city: city,
      postCode: postCode,
      date: date,
      idBufor:
        buffers.filter((el) => el.attributes.dataNadania === date).length > 0
          ? buffers.filter((el) => el.attributes.dataNadania === date)[0]
              .attributes.idBufor
          : "",
    };

    await fetch("https://apidevkppp.ftpeople.pl/addNewShipment", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setBuffer(data.przesylka);

        checkLabel(
          data.retval[0].attributes.guid,
          data.retval[0].attributes.numerNadania
        );

        setPodOdb(0);
        setCategory("EKONOMICZNA");
        setName1("");
        setName2("");
        setStreet("");
        setNum1("");
        setNum2("");
        setCity("");
        setPostCode("");
      })
      .catch((error) => {});
  };

  const fetchEdit = async () => {
    setLoading(true);
    var date = "";

    var body = {
      guid: editGuid,
    };

    await fetch("https://apidevkppp.ftpeople.pl/deleteEnvelope", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then(async (data) => {
        if (closeSend) {
          date =
            new Date().getFullYear() +
            "-" +
            (new Date().getMonth() + 1 < 10
              ? "0" + (new Date().getMonth() + 1)
              : new Date().getMonth() + 1) +
            "-" +
            (new Date().getDate() + 1 < 10
              ? "0" + (new Date().getDate() + 1)
              : new Date().getDate() + 1);
        } else {
          date =
            new Date().getFullYear() +
            "-" +
            (new Date().getMonth() + 1 < 10
              ? "0" + (new Date().getMonth() + 1)
              : new Date().getMonth() + 1) +
            "-" +
            (new Date().getDate() < 10
              ? "0" + new Date().getDate()
              : new Date().getDate());
        }

        try {
          var body = {
            podOdb: podOdb,
            category: category,
            name1: name1,
            name2: name2,
            street: street,
            num1: num1,
            num2: num2,
            city: city,
            postCode: postCode,
            date: date,
            idBufor:
              buffers.filter((el) => el.attributes.dataNadania === date)
                .length > 0
                ? buffers.filter((el) => el.attributes.dataNadania === date)[0]
                    .attributes.idBufor
                : "",
          };
        } catch (err) {}

        await fetch("https://apidevkppp.ftpeople.pl/addNewShipment", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((data) => {
            try {
              checkLabelEdit(
                data.retval[0].attributes.guid,
                data.retval[0].attributes.numerNadania
              );
            } catch (err) {}
          })
          .catch((error) => {});
      });
  };

  const checkLabelEdit = (guid, numerNadania) => {
    if (props.task !== "") {
      var body6 = {
        desc: desc,
        newNumNad: numerNadania,
        numNad: props.numNad,
      };

      fetch("https://apidevkppp.ftpeople.pl/updateDescPost", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body6),
      })
        .then((response) => response.text())
        .then((data) => {})
        .catch((error) => {});

      var body5 = {
        taskId: props.task.id,
        newNumNad: numerNadania,
        numNad: props.numNad,
      };

      fetch("https://apidevkppp.ftpeople.pl/updateTaskPost", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body5),
      })
        .then((response) => response.text())
        .then(async (dataX) => {
          var body3 = {
            taskId: props.task.id,
            value: numerNadania + " - " + name1,
            oldNumNad: props.numNad,
          };

          await fetch("https://apidevkppp.ftpeople.pl/updateNumberTask", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: secretKey,
            },
            body: JSON.stringify(body3),
          })
            .then((response) => response.text())
            .then(async (dataX) => {
              MySwal.fire({
                icon: "success",
                title: "Wydrukuj etykietę",
                text: numerNadania,
                confirmButtonText: "Dalej",
              }).then(async (result) => {
                var body = {
                  guid: guid,
                };

                await fetch("https://apidevkppp.ftpeople.pl/getLabelByGuid", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: secretKey,
                  },
                  body: JSON.stringify(body),
                })
                  .then((response) => response.json())
                  .then((data) => {
                    handleOpenPdfInNewTab(data.printResult[0].print);
                    MySwal.fire({
                      icon: "success",
                      title: "Numer nadania",
                      text: numerNadania,
                    }).then(async (result) => {
                      setLoading(false);
                      props.close();
                    });
                  })
                  .catch((error) => {});
              });
            })
            .catch((error) => {});
        })
        .catch((error) => {});
    } else {
      MySwal.fire({
        icon: "success",
        title: "Wydrukuj etykietę",
        text: numerNadania,
        confirmButtonText: "Dalej",
      }).then(async (result) => {
        var body = {
          guid: guid,
        };
        var body = {
          guid: guid,
        };

        fetch("https://apidevkppp.ftpeople.pl/getLabelByGuid", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((data) => {
            handleOpenPdfInNewTab(data.printResult[0].print);
            MySwal.fire({
              icon: "success",
              title: "Numer nadania",
              text: numerNadania,
            }).then(async (result) => {
              setLoading(false);
              props.close();
            });
          })
          .catch((error) => {});
      });
    }
  };

  const checkLabel = (guid, numerNadania) => {
    var body6 = {
      desc: desc,
      newNumNad: numerNadania,
      numNad: "",
    };

    fetch("https://apidevkppp.ftpeople.pl/updateDescPost", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body6),
    })
      .then((response) => response.text())
      .then((data) => {})
      .catch((error) => {});

    var body5 = {
      taskId: props.task ? props.task.id : "",
      newNumNad: numerNadania,
      numNad: "",
    };

    fetch("https://apidevkppp.ftpeople.pl/updateTaskPost", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body5),
    })
      .then((response) => response.text())
      .then((dataX) => {})
      .catch((error) => {});

    var body3 = {
      taskId: props.task ? props.task.id : "",
      value: numerNadania + " - " + name1,
      oldNumNad: props.numNad,
    };

    fetch("https://apidevkppp.ftpeople.pl/updateNumberTask", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body3),
    })
      .then((response) => response.text())
      .then((dataX) => {})
      .catch((error) => {});

    var body8 = {
      taskId: props.task ? props.task.id : "",
      value: guid,
      oldGuid: props.guid,
    };

    fetch("https://apidevkppp.ftpeople.pl/updateGuidTask", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body8),
    })
      .then((response) => response.text())
      .then((dataX) => {})
      .catch((error) => {});

    MySwal.fire({
      icon: "success",
      title: "Wydrukuj etykietę",
      text: numerNadania,
      confirmButtonText: "Dalej",
    }).then(async (result) => {
      var body = {
        guid: guid,
      };

      await fetch("https://apidevkppp.ftpeople.pl/getLabelByGuid", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((data) => {
          handleOpenPdfInNewTab(data.printResult[0].print);
          MySwal.fire({
            icon: "success",
            title: "Numer nadania",
            text: numerNadania,
          }).then(async (result) => {
            setLoading(false);
            props.close();
          });
        })
        .catch((error) => {});
    });
  };

  const fetchClientAddress = async () => {
    setLoading(true);
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getClientAddress", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        var arr = [];

        data
          .filter((et) => et.additionalData !== "")
          .map((el) => {
            var tmp = el.additionalData
              .replaceAll("  ", "")
              .replaceAll("ul. ", "")
              .replaceAll("ul ", "")
              .replaceAll("|", " | ")
              .split("|")
              .filter((ep) => ep !== " ");

            tmp = tmp.filter(
              (t) => t.split(",")[2] !== "" && t.split(",")[2] !== " "
            );
            if (tmp.length > 0) {
              tmp.map((ex) => {
                var tmp2 = ex.replaceAll("  ", "").split(",");
                if (tmp2[2].split(";").length > 1) {
                  var fRec = tmp2[2].split(";")[0].split(" ");
                  var sRec = "";
                  if (tmp2[2].split(";")[1][0] === " ") {
                    sRec = tmp2[2].split(";")[1].replace(" ", "").split(" ");
                  } else {
                    sRec = tmp2[2].split(";")[1].split(" ");
                  }
                  if (sRec.length > 1 && fRec.length > 1) {
                    var newR = {
                      id: el.id,
                      name: tmp2[0],
                      street: fRec[0],
                      number: fRec[1],
                      postCode: sRec[0],
                      city: sRec[1].replaceAll(".", ""),
                    };
                    arr.push(newR);
                  }
                }
              });
            }
          });
        var addr = arr.filter((el) => +el.id === +props.client.id);

        setClientsAddress(
          addr
            ? addr
            : {
                id: props.client.id,
                name: props.client.petitioner,
                street: "",
                number: "",
                postCode: "",
                city: "",
              }
        );

        if (addr) {
          var name1Q = "";
          var name2Q = "";
          if (addr[0].name.split(" ").length > 7) {
            addr[0].name.split(" ").map((el, index) => {
              if (index <= 6) {
                name1Q = name1Q + " " + el;
              } else {
                name2Q = name2Q + " " + el;
              }
            });
          } else {
            name1Q = addr[0].name;
          }
          setName1(name1Q);
          setName2(name2Q);
          setStreet(addr[0].street);
          setNum1(addr[0].number);
          setPostCode(addr[0].postCode);
          setCity(addr[0].city);
        } else {
          var name1Q = "";
          var name2Q = "";
          if (props.client.petitioner.split(" ").length > 7) {
            props.client.petitioner.split(" ").map((el, index) => {
              if (index <= 6) {
                name1Q = name1Q + " " + el;
              } else {
                name2Q = name2Q + " " + el;
              }
            });
          } else {
            name1Q = props.client.petitioner;
          }
          setName1(name1Q);
          setName2(name2Q);
          setStreet("");
          setNum1("");
          setPostCode("");
          setCity("");
        }
        fetchCourtAddress();
      })
      .catch((error) => {
        fetchCourtAddress();
      });
  };

  const fetchCourtAddress = async () => {
    var body = {
      sygn: props.client.aSygn ? props.client.aSygn.split(" ")[0] : "",
    };

    await fetch("https://apidevkppp.ftpeople.pl/getCourtAddressPost", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        var arr = [];

        data.map((el) => {
          if (el.addressNew) {
            var obj = JSON.parse(el.addressNew);
            var newR = {
              id: el.id,
              district: el.district,
              name: el.name,
              street: obj.street,
              number: obj.number,
              postCode: obj.postCode,
              city: obj.city,
            };
            arr.push(newR);
          }
        });
        var addr = {
          id: props.client.id,
          name: props.client.aCourt,
          street: "",
          number: "",
          postCode: "",
          city: "",
        };

        if (
          arr.filter((ex) => ex.name.includes(props.client.aCourt)).length > 0
        ) {
          var buf = arr.filter((ex) => ex.name.includes(props.client.aCourt));
          var dist = props.client.aSygn.split(" ")[0];
          var buf2 = buf.filter((eq) => eq.district.includes(dist));
          if (buf2.length > 0) {
            addr = {
              id: props.client.id,
              name: buf2[0].name,
              street: buf2[0].street,
              number: buf2[0].number,
              postCode: buf2[0].postCode,
              city: buf2[0].city,
            };
          } else {
            addr = {
              id: props.client.id,
              name: buf[0].name.replaceAll(
                props.client.aSygn ? props.client.aSygn.split(" ")[0] : "I",
                "I"
              ),
              street: buf[0].street,
              number: buf[0].number,
              postCode: buf[0].postCode,
              city: buf[0].city,
            };
          }
        }

        setCourtAddress(addr);
        var name1Q = "";
        var name2Q = "";
        if (addr.name.split(" ").length > 7) {
          addr.name.split(" ").map((el, index) => {
            if (index <= 6) {
              name1Q = name1Q + " " + el;
            } else {
              name2Q = name2Q + " " + el;
            }
          });
        } else {
          name1Q = addr.name;
        }
        setName1(name1Q);
        setName2(name2Q);
        setStreet(addr.street);
        setNum1(addr.number);
        setPostCode(addr.postCode);
        setCity(addr.city);

        fetchBankAddress();
      })
      .catch((error) => {
        fetchBankAddress();
      });
  };

  const fetchBankAddress = async () => {
    setLoading(true);
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getBankLawOfficeAddressPost", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        var arr = [];

        try {
          data.map((el) => {
            if (el.addressNew) {
              var obj = JSON.parse(el.addressNew);
              var newR = {
                id: el.id,
                name: el.name,
                street: obj.street,
                number: obj.number,
                postCode: obj.postCode,
                city: obj.city,
              };
              arr.push(newR);
            }
          });

          var addr = {
            id: props.client.id,
            name:
              props.client.lawyer_bank +
              " " +
              props.client.lawoffice_bank.split("\n")[0],
            street: "",
            number: "",
            postCode: "",
            city: "",
          };

          if (
            arr.filter(
              (el) => el.name === props.client.lawoffice_bank.split("\n")[0]
            )
          ) {
            var buf = arr.filter(
              (el) => el.name === props.client.lawoffice_bank.split("\n")[0]
            )[0];

            addr = {
              id: buf.id,
              name: props.client.lawyer_bank + " " + buf.name,
              street: buf.street,
              number: buf.number,
              postCode: buf.postCode,
              city: buf.city,
            };
          }
        } catch (err) {}

        setBankAddress(addr);
        fetchBank2Address();
      })
      .catch((error) => {
        fetchBank2Address();
      });
  };

  const fetchBank2Address = async () => {
    setLoading(true);
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getBankAddressPost", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        var arr = [];

        data.map((el) => {
          var obj = JSON.parse(el.addressNew);

          var newR = {
            id: el.id,
            name: el.nameLetter,
            name1: el.name,
            street: obj.street,
            number: obj.number,
            postCode: obj.postCode,
            city: obj.city,
          };
          arr.push(newR);
        });

        var addr = {
          id: props.client.id,
          name: props.client.bank,
          street: "",
          number: "",
          postCode: "",
          city: "",
        };

        if (arr.filter((el) => el.name1 === props.client.bank)) {
          var buf = arr.filter((el) => el.name1 === props.client.bank)[0];

          addr = {
            id: buf.id,
            name: buf.name,
            street: buf.street,
            number: buf.number,
            postCode: buf.postCode,
            city: buf.city,
          };
        }

        setBank2Address(addr);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const getData = () => {
    setLoading(true);
    fetchCloseSend();
  };

  useEffect(() => {
    getData();
  }, []);

  const clearData = () => {
    setPodOdb(0);
    setCategory("EKONOMICZNA");
    setName1("");
    setName2("");
    setStreet("");
    setNum1("");
    setNum2("");
    setCity("");
    setPostCode("");
  };

  const handleChangeBookMode = (e) => {
    setBookMode(e.target.value);
    if (e.target.value === "blank") {
      setName1("");
      setName2("");
      setNum1("");
      setStreet("");
      setPostCode("");
      setCity("");
    }

    if (e.target.value.includes("client")) {
      if (clientsAddress.length > 0) {
        var number = +e.target.value.replaceAll("client", "");
        clientsAddress.map((el, index) => {
          if (number === index + 1) {
            var name1Q = "";
            var name2Q = "";
            if (el.name.split(" ").length > 7) {
              el.name.split(" ").map((el, index) => {
                if (index <= 6) {
                  name1Q = name1Q + " " + el;
                } else {
                  name2Q = name2Q + " " + el;
                }
              });
            } else {
              name1Q = el.name;
            }
            setName1(name1Q);
            setName2(name2Q);
            setNum1(el.number);
            setStreet(el.street);
            setPostCode(el.postCode);
            setCity(el.city);
          }
        });
      } else {
        if (clientsAddress.length === 1) {
          var name1Q = "";
          var name2Q = "";
          if (clientsAddress[0].name.split(" ").length > 7) {
            clientsAddress[0].name.split(" ").map((el, index) => {
              if (index <= 6) {
                name1Q = name1Q + " " + el;
              } else {
                name2Q = name2Q + " " + el;
              }
            });
          } else {
            name1Q = clientsAddress[0].name;
          }
          setName1(name1Q);
          setName2(name2Q);
          setNum1(clientsAddress[0].number);
          setStreet(clientsAddress[0].street);
          setPostCode(clientsAddress[0].postCode);
          setCity(clientsAddress[0].city);
        } else {
          setPodOdb(0);
          setCategory("EKONOMICZNA");
          setName1("");
          setName2("");
          setStreet("");
          setNum1("");
          setNum2("");
          setCity("");
          setPostCode("");
        }
      }
    }
    if (e.target.value === "court") {
      if (courtAddress) {
        var name1Q = "";
        var name2Q = "";
        if (courtAddress.name.split(" ").length > 7) {
          courtAddress.name.split(" ").map((el, index) => {
            if (index <= 6) {
              name1Q = name1Q + " " + el;
            } else {
              name2Q = name2Q + " " + el;
            }
          });
        } else {
          name1Q = courtAddress.name;
        }
        setName1(name1Q);
        setName2(name2Q);
        setNum1(courtAddress.number);
        setStreet(courtAddress.street);
        setPostCode(courtAddress.postCode);
        setCity(courtAddress.city);
      } else {
        setPodOdb(0);
        setCategory("EKONOMICZNA");
        setName1("");
        setName2("");
        setStreet("");
        setNum1("");
        setNum2("");
        setCity("");
        setPostCode("");
      }
    }
    if (e.target.value === "bank") {
      if (bankAddress) {
        var name1Q = "";
        var name2Q = "";
        if (bankAddress.name.split(" ").length > 7) {
          bankAddress.name.split(" ").map((el, index) => {
            if (index <= 6) {
              name1Q = name1Q + " " + el;
            } else {
              name2Q = name2Q + " " + el;
            }
          });
        } else {
          name1Q = bankAddress.name;
        }
        setName1(name1Q);
        setName2(name2Q);
        setNum1(bankAddress.number);
        setStreet(bankAddress.street);
        setPostCode(bankAddress.postCode);
        setCity(bankAddress.city);
      } else {
        setPodOdb(0);
        setCategory("EKONOMICZNA");
        setName1("");
        setName2("");
        setStreet("");
        setNum1("");
        setNum2("");
        setCity("");
        setPostCode("");
      }
    }
    if (e.target.value === "bank2") {
      if (bank2Address) {
        var name1Q = "";
        var name2Q = "";
        if (bank2Address.name.split(" ").length > 7) {
          bank2Address.name.split(" ").map((el, index) => {
            if (index <= 6) {
              name1Q = name1Q + " " + el;
            } else {
              name2Q = name2Q + " " + el;
            }
          });
        } else {
          name1Q = bank2Address.name;
        }
        setName1(name1Q);
        setName2(name2Q);
        setNum1(bank2Address.number);
        setStreet(bank2Address.street);
        setPostCode(bank2Address.postCode);
        setCity(bank2Address.city);
      } else {
        setPodOdb(0);
        setCategory("EKONOMICZNA");
        setName1("");
        setName2("");
        setStreet("");
        setNum1("");
        setNum2("");
        setCity("");
        setPostCode("");
      }
    }
  };

  return (
    <>
      <div
        className="mainContainerAddClientContact"
        style={{
          backgroundColor: "white",
          position: "fixed",
          right: "0",
          top: "5vh",
          width: "80%",
          maxHeight: "80vh",
          overflow: "scroll",
        }}
      >
        <div
          style={{ width: "100%", marginBottom: "1vh" }}
          className="closeBox"
        >
          <button className="closeClientButton" onClick={props.close}>
            X
          </button>
        </div>
        {loading ? (
          <>
            <Loading />
          </>
        ) : (
          <>
            {true ? (
              <>
                <div style={{ width: "60%" }}>
                  <div className="inputBox">
                    <div className="inputCol_1">
                      <label>KsiąŻka adresowa</label>
                      <select
                        style={{ boxSizing: "border-box" }}
                        type="text"
                        id="name"
                        name="name"
                        value={bookMode}
                        onChange={handleChangeBookMode}
                      >
                        <>
                          <option key={1} value={"court"}>
                            SĄD
                          </option>
                          <option key={2} value={"bank"}>
                            PEŁNOMOCNIK BANKU
                          </option>
                          <option key={3} value={"bank2"}>
                            BANK
                          </option>
                          {clientsAddress.length > 0 ? (
                            clientsAddress.map((el, index) => (
                              <option key={4} value={"client" + (index + 1)}>
                                KLIENT {index + 1}
                              </option>
                            ))
                          ) : (
                            <option key={4} value={"client"}>
                              KLIENT
                            </option>
                          )}

                          <option key={5} value={"blank"}>
                            PUSTY
                          </option>
                        </>
                      </select>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              ""
            )}

            <div
              style={{
                display: "flex",
                alignItems: "center",
                height: "5vh",
                width: "100%",
              }}
            ></div>
            <div style={{ width: "80%" }}>
              <div className="inputBox">
                <div className="inputCol_2">
                  <label>Potwierdzenie odbioru </label>
                  <select
                    style={{ boxSizing: "border-box" }}
                    type="text"
                    id="name"
                    name="name"
                    value={podOdb}
                    onChange={(e) => {
                      setPodOdb(e.target.value);
                    }}
                  >
                    <>
                      <option key={0} value={1}>
                        TAK
                      </option>
                      <option key={1} value={0}>
                        NIE
                      </option>
                    </>
                  </select>
                </div>
                <div className="inputCol_2">
                  <label>Rodzaj przesyłki</label>
                  <select
                    style={{ boxSizing: "border-box" }}
                    type="text"
                    id="name"
                    name="name"
                    value={category}
                    onChange={(e) => {
                      setCategory(e.target.value);
                    }}
                  >
                    <>
                      <option key={0} value={"EKONOMICZNA"}>
                        EKONOMICZNA
                      </option>
                      <option key={1} value={"PRIORYTETOWA"}>
                        PRIORYTETOWA
                      </option>
                    </>
                  </select>
                </div>
              </div>

              <div className="inputBox">
                <div className="inputCol_2">
                  <label>Nazwa 1</label>
                  <input
                    style={{ boxSizing: "border-box" }}
                    type="text"
                    id="name"
                    name="name"
                    value={name1}
                    onChange={(e) => {
                      setName1(e.target.value);
                    }}
                  />
                </div>
                <div className="inputCol_2">
                  <label>Nazwa 2</label>
                  <input
                    style={{ boxSizing: "border-box" }}
                    type="text"
                    id="name"
                    name="name"
                    value={name2}
                    onChange={(e) => {
                      setName2(e.target.value);
                    }}
                  />
                </div>
              </div>

              <div className="inputBox">
                <div className="inputCol_2">
                  <label>Ulica</label>
                  <input
                    style={{ boxSizing: "border-box" }}
                    type="text"
                    id="name"
                    name="name"
                    value={street}
                    onChange={(e) => {
                      setStreet(e.target.value);
                    }}
                  />
                </div>
                <div className="inputCol_2">
                  <label>Numer domu</label>
                  <input
                    style={{ boxSizing: "border-box" }}
                    type="text"
                    id="name"
                    name="name"
                    value={num1}
                    onChange={(e) => {
                      setNum1(e.target.value);
                    }}
                  />
                </div>
              </div>

              <div className="inputBox">
                <div className="inputCol_2">
                  <label>Numer lokalu</label>
                  <input
                    style={{ boxSizing: "border-box" }}
                    type="text"
                    id="name"
                    name="name"
                    value={num2}
                    onChange={(e) => {
                      setNum2(e.target.value);
                    }}
                  />
                </div>
                <div className="inputCol_2">
                  <label>Miejscowość</label>
                  <input
                    style={{ boxSizing: "border-box" }}
                    type="text"
                    id="name"
                    name="name"
                    value={city}
                    onChange={(e) => {
                      setCity(e.target.value);
                    }}
                  />
                </div>
              </div>

              <div className="inputBox">
                <div className="inputCol_2">
                  <label>Kod pocztowy</label>
                  <input
                    style={{ boxSizing: "border-box" }}
                    type="text"
                    id="name"
                    name="name"
                    value={postCode}
                    onChange={(e) => {
                      setPostCode(e.target.value);
                    }}
                  />
                </div>
              </div>

              <div className="inputBox">
                <div className="inputCol_1" style={{ width: "100%" }}>
                  <label>Opis</label>
                  <textarea
                    style={{
                      boxSizing: "border-box",
                      resize: "none",
                      height: "10vh",
                    }}
                    value={desc}
                    onChange={(e) => {
                      setDesc(e.target.value);
                    }}
                  />
                </div>
              </div>

              <div
                className="saveBoxAP"
                style={{ display: "flex", gap: "2vw" }}
              >
                {props.mode === "edit" ? (
                  <>
                    <button className="paymentMenuButton" onClick={fetchEdit}>
                      edytuj
                    </button>
                  </>
                ) : (
                  <>
                    <button className="paymentMenuButton" onClick={fetchAdd}>
                      wyślij
                    </button>
                  </>
                )}
                <button className="paymentMenuButton" onClick={clearData}>
                  wyczyść
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default SendPostTask;
